var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { Box, Button, Dialog, DialogContent, LinearProgress, SvgIcon, TextField, Tooltip, } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CopyToClipBoard from 'react-copy-to-clipboard';
import { QuerySqlDocument } from '../../generated/graphql';
import mutationVariables from '../../utility/mutationVariables';
import theme from '../theme';
var QueryUpdater = function (_a) {
    var datasourceId = _a.datasourceId, defaultSql = _a.defaultSql, query = _a.query, setQuery = _a.setQuery, variables = _a.variables, setVariables = _a.setVariables, setRows = _a.setRows;
    var _b = useState(false), queryLoading = _b[0], setQueryLoading = _b[1];
    var _c = useState(false), sqlUpdated = _c[0], setSqlUpdated = _c[1];
    var _d = React.useState({ dialog: false, compound: false, clip: false }), open = _d[0], setOpen = _d[1];
    var _e = useState(), compoundQuery = _e[0], setCompoundQuery = _e[1];
    var _f = useMutation(QuerySqlDocument, {
        onCompleted: function (data) {
            setRows(data.querySql.results);
        },
    }), runQuery = _f[0], loading = _f[1].loading;
    useEffect(function () {
        setQuery(defaultSql.query);
        setVariables(defaultSql.variables);
        setCompoundQuery(defaultSql.compoundQuery);
    }, [defaultSql]);
    var handleClose = function (key) {
        setOpen({ dialog: false, compound: false, clip: false });
    };
    var handleOpen = function (key) {
        var _a;
        setOpen(__assign(__assign({}, open), (_a = {}, _a[key] = true, _a)));
    };
    var handleChangeQuery = function (event) {
        setQuery(event.target.value);
        setSqlUpdated(defaultSql.query !== event.target.value);
        setCompoundQuery(generateCompoundQuery(event.target.value, variables));
    };
    var handleChangeVariables = function (event) {
        setVariables(JSON.parse(event.target.value));
        setSqlUpdated(JSON.stringify(defaultSql.variables) !== event.target.value);
        setCompoundQuery(generateCompoundQuery(query, JSON.parse(event.target.value)));
    };
    var generateCompoundQuery = function (query, variables) {
        var compound = query;
        for (var x in variables) {
            compound = compound.replace(new RegExp("{{\\s*" + x + "\\s*}}", 'g'), variables[x]);
        }
        return compound;
    };
    var handleUpdateQuery = function () {
        var sql = query;
        if (variables) {
            sql = generateCompoundQuery(query, variables);
            setCompoundQuery(sql);
        }
        runQuery(mutationVariables({ datasourceId: datasourceId, query: sql }));
    };
    return (React.createElement(UpdaterBox, null,
        React.createElement(SqlBox, null,
            React.createElement(UpdateQueryTextField, { label: "SQL Query", multiline: true, variant: "outlined", rows: 10, rowsMax: 12, value: query, onChange: handleChangeQuery }),
            variables ? (React.createElement(UpdateVariableTextField, { label: "Template Variables", multiline: true, variant: "outlined", rows: 10, rowsMax: 12, value: JSON.stringify(variables), onChange: handleChangeVariables })) : null),
        sqlUpdated ? (React.createElement(DiffButton, { variant: "contained", color: "secondary", disabled: loading, onClick: handleUpdateQuery }, "Check Diff")) : null,
        compoundQuery && variables ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: function () { return handleOpen('dialog'); }, style: { float: 'right' } },
                "compound query ",
                React.createElement(CompoundIcon, null)),
            React.createElement(CompoundDialog, { onClose: function () { return handleClose('dialog'); }, open: open.dialog, BackdropProps: {
                    style: { backgroundColor: 'transparent' },
                }, PaperProps: { elevation: 1 } },
                React.createElement(DialogContent, null,
                    React.createElement(CompoundTooltip, { title: compoundQuery, placement: "left-end", onClose: function () { return handleClose('compound'); }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, open: open.compound },
                        React.createElement(Button, { onClick: function () { return handleOpen('compound'); } }, "view SQL")),
                    React.createElement(Tooltip, { title: "copied!", onClose: function () { return handleClose('clip'); }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, open: open.clip },
                        React.createElement(CopyToClipBoard, { text: compoundQuery },
                            React.createElement(Button, { onClick: function () { return handleOpen('clip'); } },
                                "Copy to Clipboard",
                                React.createElement(FileCopyIcon, null)))))))) : null,
        loading ? React.createElement(LinearProgress, null) : null));
};
var UpdaterBox = withStyles({
    root: {
        minHeight: 360,
        flex: 4,
    },
})(Box);
var SqlBox = withStyles({
    root: {
        maxHeight: 300,
        display: 'flex',
    },
})(Box);
var UpdateQueryTextField = withStyles({
    root: {
        height: '100%',
        flex: 2,
        backgroundColor: theme.palette.common.white,
        '& .MuiOutlinedInput-root': {
            color: theme.palette.text.secondary,
            '&.Mui-focused': {
                color: theme.palette.text.primary,
            },
        },
    },
})(TextField);
var UpdateVariableTextField = withStyles({
    root: {
        height: '100%',
        flex: 1,
        backgroundColor: theme.palette.common.white,
        '& .MuiOutlinedInput-root': {
            color: theme.palette.text.secondary,
            '&.Mui-focused': {
                color: theme.palette.text.primary,
            },
        },
    },
})(TextField);
var DiffButton = withStyles({
    root: {
        backgroundColor: theme.palette.neutral.main,
        borderColor: theme.palette.neutral.main,
        float: 'right',
    },
})(Button);
var CompoundDialog = withStyles({
    root: {
        position: 'absolute!important',
        maxWidth: 1280,
        paddingLeft: 24,
        paddingRight: 24,
        margin: 'auto',
    },
    paper: {
        marginLeft: 'auto',
        marginRight: 0,
        '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
        },
    },
})(Dialog);
var CompoundTooltip = withStyles({
    tooltip: {
        margin: 20,
        fontSize: theme.typography.pxToRem(12),
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        border: '1px solid ' + theme.palette.mono.main,
        maxWidth: 'none',
        whiteSpace: 'pre-wrap',
    },
})(Tooltip);
var CompoundIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("g", null,
        React.createElement("circle", { cx: "9.5", cy: "12.5", r: "1.5", fill: "#444444", "data-color": "color-2" }),
        React.createElement("path", { d: "M15,6.523V2h2V0H7V2H9V6.523a9,9,0,1,0,6,0ZM12,15a6.986,6.986,0,0,1-7,.083c0-.028,0-.055,0-.083a6.994,6.994,0,0,1,6-6.92V2h2V8.08a6.993,6.993,0,0,1,6,6.837A6.986,6.986,0,0,0,12,15Z" })))); };
export default QueryUpdater;
